<template>
    <div>

        <div class="card dashcard mb-0">

            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" /> 
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-warehouse fa-fw"
                            placeholder="Todos..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="id_estoque_local" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-regular fa-calendar fa-fw"
                            type="select"
                            placeholder="Data Registro"
                            :optionsList="[
                                { id: 'M', search: 'Data Movimentação' },
                            ]" 
                            optionsData="id" 
                            v-model="filtro.tipo_data" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            placeholder="Todos os Itens..."
                            optionsMode="json"
                            :optionsList="item_classes" 
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.classe">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-primary" @click="incluir_filtro()">
                                        <i class="fas fa-filter fa-fw"></i>
                                        <span class="badge badge-primary ml-1" v-if="lista_add_filtros && lista_add_filtros.length">
                                            {{ lista_add_filtros.length }}
                                        </span>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fab fa-google fa-fw"
                            placeholder="Todos os Grupos..."
                            type="select"
                            service="estoque_grupos.index"
                            optionsData="id_estoque_grupo"
                            optionsMode="aql"
                            v-model="id_estoque_grupo" />
                    </div>
                    <div class="col col-12 col-md-2" v-if="false">
                        <az-input
                            icon="fas fa-object-group fa-fw"
                            placeholder="Por Grupo"
                            type="select"
                            :optionsList="[
                                { id: 'L', search: 'Por Local de Armazenagem' },
                            ]"
                            optionsData="id"
                            v-model="filtro.tipo_agrupa" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="select"
                            icon="fas fa-object-group fa-fw"
                            placeholder="Analítico"
                            :optionsList="[
                                { id: 'S', search: 'Sintético' },
                            ]"
                            optionsData="id"
                            v-model="filtro.sintetico">
                            <template v-slot:buttonposb>
                                <print-export
                                    printid="lista-saldos"
                                    :left="true"
                                    :dados="dados_saldos" />
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            type="checkbox-group"
                            label="Exibir Quantidades"
                            :edicao="!filtro.sintetico"
                            v-model="exibir_qtds" />
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-1">
            <div class="indeterminate" v-if="$store.state.loading && !dados_saldos.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state
            :msg="firstLoad ? 'Nenhum item encontrado.' : 'Buscar Variação de Saldos...'"
            :icon="firstLoad ? 'fas fa-balance-scale-right' : 'fas fa-sync-alt'"
            v-if="!dados || dados.vazio" />

        <template v-else>

            <div class="alert alert-info mt-2">
                Período: {{ $util.getFormatDate(dados.filtros.inicio) }} a {{ $util.getFormatDate(dados.filtros.fim) }} ({{ dados.tipo_data }})
                <div v-if="dados.filtros.unidade">
                    Unidade: {{ dados.filtros.unidade.st_nome }}
                </div>
                <div v-if="dados.filtros.local">
                    Local: {{ dados.filtros.local.search }}
                </div>
                <div v-if="dados.filtros.grupo">
                    Grupo: {{ dados.filtros.grupo.search }}
                </div>
            </div>

            <div id="lista-saldos">

                <cabecalho-generico titulo="Saldos">
                    <div>
                        Período: {{ $util.getFormatDate(dados.filtros.inicio) }} a {{ $util.getFormatDate(dados.filtros.fim) }}
                    </div>
                    <div v-if="dados.filtros.unidade">
                        Unidade: {{ dados.filtros.unidade.st_nome }}
                    </div>
                    <div v-if="dados.filtros.local">
                        Local: {{ dados.filtros.local.search }}
                    </div>
                    <div v-if="dados.filtros.grupo">
                        Grupo: {{ dados.filtros.grupo.search }}
                    </div>
                </cabecalho-generico>

                <table class="table table-sm table-hover bg-white small">
                    <thead>
                        <tr>
                            <th>Descrição ({{ dados.items.length }})</th>
                            <th class="text-right">Saldo Anterior</th>
                            <th class="text-right" v-for="(tipo, itx) in dados.tipos" :key="itx">{{ tipo.search }}</th>
                            <th class="text-right">Saldo Final</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, iix) in dados.items" :key="iix">
                            <td>{{ item.search }}</td>
                            <td class="text-right">
                                {{ $util.formatMoeda(item.saldo_anterior) }}
                                <div v-if="!dados.filtros.sintetico && exibir_qtds">
                                    {{ item.qtd_anterior }}
                                </div>
                            </td>
                            <td class="text-right" v-for="(tipo, itx) in dados.tipos" :key="itx">
                                <span :class="!item[tipo.id] ? 'text-muted' : ''">{{ $util.formatMoeda(item[tipo.id]) }}</span>
                                <div v-if="!dados.filtros.sintetico && exibir_qtds" :class="!item['Q' + tipo.id] ? 'text-muted' : ''">
                                    {{ $util.formatMoeda(item['Q' + tipo.id], 0) }}
                                </div>
                            </td>
                            <td class="text-right">
                                {{ $util.formatMoeda(item.saldo_final) }}
                                <div v-if="!dados.filtros.sintetico && exibir_qtds">
                                    {{ item.qtd_final }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Total</th>
                            <th class="text-right">{{ $util.formatMoeda(total('saldo_anterior')) }}</th>
                            <th class="text-right" v-for="(tipo, itx) in dados.tipos" :key="itx">{{ $util.formatMoeda(total(tipo.id)) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(total('saldo_final')) }}</th>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </template>

        <pre class="alert alert-info" v-if="false">{{ dados }}</pre>

        <!-- Filtros -->
        <crm-filtros ref="filtros" model_type="App\azure\estoqueItem" @refresh="atualizar_filtros"/>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import CrmFiltros from '../crm/CrmFiltros.vue';

export default {
    data () {
        return {
            dados: null,
            search: "",
            referencia: this.$util.hoje(),
            viewMode: "S",
            material: null,
            id_unidade_operacao: "",
            id_estoque_local: "",
            id_estoque_grupo_local: "",
            lote_selecionado: null,
            firstLoad: false,
            print_id: "lista-saldos",
            dados_busca: null,
            tipoParm: 'P',
            var_tempo: null,
            tempo: "",
            tag_selecionada: "",
            id_estoque_grupo: "",
            nova_aq: null,
            validate: false,
            filtro: {
                inicio: "",
                fim: "",
                periodo: "ma",
                sintetico: "S", 
                classe: "", 
                tipo_agrupa: "", 
                tipo_data: "", 
            },
            exibir_qtds: false, 
            item_classes: [], 
            lista_add_filtros: [], 
        }
    },

    components: {
        AzInput,
        AzEmptyState,
        PrintExport,
        CabecalhoGenerico,
        AzPeriodo,
        CrmFiltros,
    },

    computed: {

        mostrar_qtd: function () { 
            return this.dados && this.dados.filtros && !this.dados.filtros.sintetico && this.exibir_qtds;
        },

        
        dados_saldos: function () {
            if ( !this.dados || !this.dados.items || !this.dados.items.length )
                return [];

            return this.dados.items.map(item => {
                let linha = {
                    descricao: item.search,
                    saldo_anterior: this.$util.formatMoeda(item.saldo_anterior)
                };

                if ( this.mostrar_qtd ) { 
                    linha['qtd_anterior'] = this.$util.formatMoeda(item.qtd_anterior, 0)
                }

                this.dados.tipos.forEach(tipo => { 
                    linha[tipo.search] = this.$util.formatMoeda(_.get(item, tipo.id, 0));

                    if ( this.mostrar_qtd ) { 
                        linha['qtd_' + tipo.search] = this.$util.formatMoeda(_.get(item, 'Q' + tipo.id, 0), 0)
                    }
                });

                linha.saldo_final = this.$util.formatMoeda(item.saldo_final);

                if ( this.mostrar_qtd ) { 
                    linha['qtd_final'] = this.$util.formatMoeda(item.qtd_final, 0)
                }

                return linha;
            });
        },

    },

    methods: {
        incluir_filtro () { 
            this.$refs.filtros.abrir(0); 
        },

        atualizar_filtros () { 
            this.lista_add_filtros = ( this.$refs.filtros ? this.$refs.filtros.get_filtros(0) : [] ); 
        },

        total (campo) { 
            return this.dados.items.reduce((total, carry) => { 
                return total + parseFloat(carry[campo]);
            }, 0);
        },

        load() {

            this.dados_busca = {
                ...this.filtro,
                id_estoque_local: this.id_estoque_local,
                id_unidade_operacao: this.id_unidade_operacao,
                id_estoque_grupo: this.id_estoque_grupo,
            };

            this.$util.load(this, {
                service: 'estoque',
                func: 'variacao_saldo',
                parms: {
                    ...this.dados_busca,
                    add_filtros: this.lista_add_filtros, 
                }
            });

            this.firstLoad = true;

        }

    },

    mounted() {

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Variação de Saldo", path: "/suprimentos/saldo-variacao" }
        ]);

        this.$util.loadItem(this, { 
            service: 'estoque_items',
            func: 'tags',
        })
        .then(res => { 
            this.item_classes = res.map(item => { 
                return { 
                    id: item,
                    search: item,
                };
            });
        });

    },

    updated() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    },

}
</script>
